export const SETTINGS_AUTOCOMPLETE_KEY = 'autocomplete';

export const SETTINGS_ACCESSOR_CONFIG = {
    [SETTINGS_AUTOCOMPLETE_KEY]: {
        mode: null,
        controls: {},
    },
};
